import acturugby from './actu-rugby.js'
import defaut from './default.js'
import rosselBelgique from './rosselBelgique.js'

export const themes = {
    "testprovider" : acturugby,
    "rossel-belgique" : rosselBelgique,
    "default" : defaut
}